import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { UserInterface } from 'src/app/model/user/user-interface';
import { DialogService } from '../dialog-service/dialog-service.service';
import { Observable } from 'rxjs';

const SWARM_API = '/proxy/api/v0/userservice';
const ACCOUNT_PREFIX = '/accounts';
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    })
};

@Injectable({
    providedIn: 'root'
})
export class RegistrationService {
    constructor(
        private http: HttpClient,
        private router: Router,
        private dialogService: DialogService
    ) {}

    public register(user): Observable<UserInterface> {
        const json = JSON.stringify(user);
        return this.http.post<UserInterface>(
            SWARM_API + ACCOUNT_PREFIX + '/registration',
            json,
            httpOptions
        );
    }

    public registerWithCode(user, code): Observable<UserInterface> {
        const json = JSON.stringify(user);
        return this.http.post<UserInterface>(
            SWARM_API + ACCOUNT_PREFIX + '/registration/' + code,
            json,
            httpOptions
        );
    }

    public registerWithoutNeedingConfirmation(
        user: UserInterface
    ): Observable<UserInterface> {
        const json = JSON.stringify(user);
        return this.http.post<UserInterface>(
            SWARM_API + ACCOUNT_PREFIX + '/registration/invited',
            json,
            httpOptions
        );
    }

    public confirmRegistration(token: string) {
        let params = new HttpParams();
        params = params.append('token', token);
        return this.http.put(
            `${SWARM_API}${ACCOUNT_PREFIX}/registration/activate`,
            '',
            { params: params }
        );
    }

    public resetPassword(username: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http
                .put<UserInterface>(
                    SWARM_API + ACCOUNT_PREFIX + '/resetPassword',
                    username,
                    httpOptions
                )
                .subscribe(
                    () => {
                        resolve(true);
                    },
                    (error: HttpErrorResponse) => {
                        if (error.status === 409) {
                            this.resendMail(username);
                            this.dialogService
                                .openDialog(
                                    'Passwort Zurücksetzen fehlgeschlagen',
                                    'Ihr Account wurde noch nicht über den Link in der Aktivierungsmail bestätigt. ' +
                                        'Die Aktivierungsmail wurde erneut gesendet und wird innerhalb der nächsten Minuten ankommen. ' +
                                        'Nach erfolgreicher Aktivierung können Sie sich einloggen und auf Ihren Account zugreifen oder bei Bedarf Ihr Passwort zurücksetzen.'
                                )
                                .subscribe(() => {
                                    this.router.navigate(['login']);
                                });
                        }
                        reject(false);
                    }
                );
        });
    }

    public resetLoginAttempts(username: string): Promise<boolean> {
        const SWARM_API_PCSSO = '/proxy/api/v0/pcssoservice/';

        return new Promise((resolve, reject) => {
            this.http
                .get(
                    SWARM_API_PCSSO +
                        'oauth/resetRestrictionCooldown/' +
                        username,
                    httpOptions
                )
                .subscribe(
                    () => {
                        resolve(true);
                    },
                    () => {
                        reject(false);
                    }
                );
        });
    }

    public resendMail(username: string): Promise<boolean> {
        return new Promise((resolve, reject) => {
            this.http
                .put<UserInterface>(
                    SWARM_API + ACCOUNT_PREFIX + '/resendMail',
                    username,
                    httpOptions
                )
                .subscribe(
                    () => {
                        resolve(true);
                    },
                    () => {
                        reject(false);
                    }
                );
        });
    }

    public checkIfUserHasBeenInvited(token: string): Observable<string> {
        const requestOptions: Object = {
            responseType: 'text'
        };
        return this.http.get<string>(
            SWARM_API + ACCOUNT_PREFIX + '/invitation/' + token,
            requestOptions
        );
    }

    verifyNewUserName(token: string, isNewMail: boolean) {
        const USER_PREFIX = '/users';
        let params = new HttpParams();
        params = params.append('token', token);
        let suffix: string = isNewMail ? 'newMail' : 'oldMail';
        const url = SWARM_API + USER_PREFIX + '/verify/' + suffix;
        return this.http.put(url, '', { params: params });
    }
}
